<!-- Mostrar el carrito como modal o como página según el contexto -->
<div *ngIf="isOpen" class="cart-overlay" (click)="onOverlayClick($event)" [@fadeAnimation]>
  <!-- Panel lateral del carrito -->
  <div class="cart-panel" [@slideAnimation]>
    <!-- Encabezado del carrito -->
    <div class="cart-header">
      <h2 class="cart-title">
        <svg class="cart-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
        Carrito de Compras
        <span class="cart-badge" *ngIf="totalItems > 0">{{ totalItems }}</span>
      </h2>
      <button class="close-button" (click)="closeCart()" aria-label="Cerrar carrito">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <!-- Contenido del carrito -->
    <div class="cart-content">
      <!-- Carrito vacío -->
      <div *ngIf="cartItems.length === 0" class="empty-cart">
        <svg class="empty-cart-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
        <h3>Tu carrito está vacío</h3>
        <p>Agrega productos para comenzar tu compra</p>
      </div>
      <!-- Lista de items -->
      <div *ngIf="cartItems.length > 0" class="cart-items-list">
        <div *ngFor="let item of cartItems; let i = index" class="cart-item">
          <!-- Imagen del producto -->
          <div class="item-image">
            <img [src]="item.product.images || 'assets/placeholder.png'" [alt]="item.product.description"
              onerror="this.src='assets/placeholder.png'">
          </div>
          <!-- Detalles del producto -->
          <div class="item-details">
            <h4 class="item-name">{{ item.product.description || 'Producto' }}</h4>
            <p class="item-price">${{ item.product.price || 0 | number:'1.2-2' }}</p>
            <!-- Controles de cantidad -->
            <div class="quantity-controls">
              <button class="quantity-btn" (click)="updateQuantity(i, -1)" aria-label="Disminuir cantidad">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                </svg>
              </button>
              <span class="quantity-value">{{ item.quantity }}</span>
              <button class="quantity-btn" (click)="updateQuantity(i, 1)" aria-label="Aumentar cantidad">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
              </button>
            </div>
          </div>
          <!-- Botón eliminar -->
          <button class="remove-btn" (click)="removeItem(i)" aria-label="Eliminar producto">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- Footer del carrito -->
    <div *ngIf="cartItems.length > 0" class="cart-footer">
      <!-- Total -->
      <div class="cart-total">
        <span class="total-label">Total:</span>
        <span class="total-amount">${{ totalPrice | number:'1.2-2' }}</span>

      </div>
      <div class="cart-total">
        <span *ngIf="bcv > 0" class="text-xl font-semibold text-gray-600 dark:text-gray-400 flex items-center gap-2">
          Bs. {{ (totalPrice * bcv) | number:'1.2-2' }}
          <span
            class="inline-flex items-center px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-800 text-xs font-normal text-gray-500 dark:text-gray-400">
            Ref. BCV: {{ bcv | number:'1.2-2' }}
          </span>
        </span>

      </div>
      <!-- Botones de acción -->
      <div class="cart-actions">
        <button class="btn-clear" (click)="clearCart()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Vaciar carrito
        </button>
        <!-- <button class="btn-checkout">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Proceder al pago
        </button> -->
            <button 
            (click)="irAWhatsApp('584140823255', 'Hola! escribo desde ghouse app, estoy interesado en los productos: ' + totalItems + 'por un total de '+ totalPrice + '. ¿Podrías darme más información?' )" routerLink="/checkout" class="btn-checkout">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Proceder al pago
        </button>
      </div>
    </div>
  </div>
</div>